export function getPackageTypeById({packages, id, fallback = '-'}) {
  return packages?.find((item) => item.id === id)?.type || fallback;
}
